import { browserHistory } from 'common/utils/browserHistory';

function goToCaseAsSentReferral({ caseId, contactId, pathname }) {
  browserHistory.push(`${pathname}/${caseId}/contact/${contactId}`);
}

export default goToCaseAsSentReferral;
